import focusLock from 'dom-focus-lock';
import { lock, unlock } from 'tua-body-scroll-lock';

const wrapperStyles = `
  position: fixed !important;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  z-index: 9999999;
  display: block !important;
  width: 100vw;
  height: 100%;
  margin: 0 !important;
  padding: 0 !important;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  background: rgba(0, 0, 0, 0.6);
`;
const iframeStyles = `
  position: absolute !important;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  width: 100vw;
  height: 100%;
  margin: 0 !important;
  padding: 0 !important;
  background: none;
  border: none
`;
const iframeEmbeddedStyles = `
  position: static;
  width: 100%;
  height: 100%;
`;

const createEmbeddedIFrame = function (frame) {
  let embeddedOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let isVeriffIframeMobile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const {
    rootElementID
  } = embeddedOptions;
  if (isVeriffIframeMobile) {
    frame.style.cssText = iframeStyles;
    const wrapper = document.createElement('div');
    wrapper.style.cssText = wrapperStyles;
    wrapper.appendChild(frame);
    document.body.appendChild(wrapper);
    focusLock.on(frame);
    lock(frame);
  } else {
    if (!rootElementID) {
      throw new Error('rootElementID must be specified in embedded mode');
    }
    if (!document.getElementById(rootElementID)) {
      throw new Error('rootElementID must point to an existing DOM element');
    }
    frame.style.cssText = iframeEmbeddedStyles;
    document.getElementById(rootElementID).appendChild(frame);
  }
};

let IFRAME_MESSAGES = function (IFRAME_MESSAGES) {
  IFRAME_MESSAGES["VERIFF_HANDSHAKE"] = "VERIFF_HANDSHAKE";
  IFRAME_MESSAGES["VERIFF_RENDER"] = "VERIFF_RENDER";
  IFRAME_MESSAGES["VERIFF_STARTED"] = "VERIFF_STARTED";
  IFRAME_MESSAGES["VERIFF_SUBMITTED"] = "VERIFF_SUBMITTED";
  IFRAME_MESSAGES["VERIFF_FINISHED"] = "VERIFF_FINISHED";
  IFRAME_MESSAGES["VERIFF_CANCELED"] = "VERIFF_CANCELED";
  IFRAME_MESSAGES["VERIFF_FORCE_RELOAD"] = "VERIFF_FORCE_RELOAD";
  IFRAME_MESSAGES["VERIFF_RELOAD_REQUEST"] = "VERIFF_RELOAD_REQUEST";
  return IFRAME_MESSAGES;
}({});

let MESSAGES = function (MESSAGES) {
  MESSAGES["STARTED"] = "STARTED";
  MESSAGES["SUBMITTED"] = "SUBMITTED";
  MESSAGES["FINISHED"] = "FINISHED";
  MESSAGES["CANCELED"] = "CANCELED";
  MESSAGES["RELOAD_REQUEST"] = "RELOAD";
  return MESSAGES;
}({});

const IFRAME_ID = 'veriffFrame';
function handleHandshakeEvent(frame, payload) {
  frame.contentWindow?.postMessage({
    name: IFRAME_MESSAGES.VERIFF_RENDER,
    payload
  }, '*');
}
function checkIfIsVeriffIframeMobile(embedded) {
  if (embedded) {
    try {
      const mediaQuery = matchMedia('(max-width: 767px), (hover: none)');
      return mediaQuery.matches;
    } catch (e) {
      console.error('Error while checking if iframe is mobile', e);
      return false;
    }
  }
  return false;
}
function appendParamToUrl(url, name, value) {
  if (value) {
    const newUrl = new URL(url);
    const params = newUrl.searchParams;
    params.set(name, value);
    newUrl.search = params.toString();
    return newUrl.toString();
  }
  return url;
}
function createWrapper() {
  const wrapper = document.createElement('div');
  wrapper.style.cssText = wrapperStyles;
  return wrapper;
}
function createIframe(url, embedded, embeddedOptions, isVeriffIframeMobile) {
  const frame = document.createElement('iframe');
  frame.src = url;
  frame.allow = 'autoplay; camera; microphone; fullscreen; accelerometer; magnetometer; gyroscope; picture-in-picture;';
  frame.id = IFRAME_ID;
  if (embedded) {
    createEmbeddedIFrame(frame, embeddedOptions, isVeriffIframeMobile);
  } else {
    frame.style.cssText = iframeStyles;
    const wrapper = createWrapper();
    wrapper.appendChild(frame);
    document.body.appendChild(wrapper);
    focusLock.on(frame);
    lock(frame);
  }
  return frame;
}
function createVeriffFrame(_ref) {
  let {
    url,
    lang,
    onEvent = () => {
      return;
    },
    embedded = false,
    embeddedOptions,
    onReload
  } = _ref;
  if (!url) {
    throw new Error('URL is not provided. Please provide a valid Veriff session url.');
  }
  const isVeriffIframeMobile = checkIfIsVeriffIframeMobile(embedded);
  function closeIframe() {
    const frame = document.getElementById(IFRAME_ID);
    if (frame && frame.parentNode) {
      focusLock.off(frame);
      unlock(frame);
      let wrapper = frame.parentNode.parentNode;
      let child = frame.parentNode;
      if (embedded && !isVeriffIframeMobile) {
        wrapper = frame.parentNode;
        child = frame;
      }
      if (wrapper) wrapper.removeChild(child);
    } else {
      unlock();
    }
    window.removeEventListener('message', handleMessage);
  }
  function handleMessage(event) {
    const frame = document.getElementById(IFRAME_ID);
    const version = "2.4.0";
    if (event.data === IFRAME_MESSAGES.VERIFF_HANDSHAKE) {
      handleHandshakeEvent(frame, {
        version,
        isReloadHandled: typeof onReload === 'function',
        isVeriffIframeMobile,
        embeddedConfigured: embedded,
        embedded: isVeriffIframeMobile ? false : embedded
      });
    }
    if (event.data === IFRAME_MESSAGES.VERIFF_STARTED) {
      onEvent(MESSAGES.STARTED);
    }
    if (event.data === IFRAME_MESSAGES.VERIFF_CANCELED) {
      closeIframe();
      onEvent(MESSAGES.CANCELED);
    }
    if (event.data === IFRAME_MESSAGES.VERIFF_SUBMITTED) {
      onEvent(MESSAGES.SUBMITTED);
    }
    if (event.data === IFRAME_MESSAGES.VERIFF_FINISHED) {
      closeIframe();
      onEvent(MESSAGES.FINISHED);
    }
    if (event.data === IFRAME_MESSAGES.VERIFF_FORCE_RELOAD) {
      window.location.reload();
    }
    if (event.data === IFRAME_MESSAGES.VERIFF_RELOAD_REQUEST) {
      if (typeof onReload === 'function') {
        onReload();
      }
      onEvent(MESSAGES.RELOAD_REQUEST);
    }
  }
  const newUrl = lang && lang.length > 0 ? appendParamToUrl(url, 'lang', lang) : url;
  createIframe(newUrl, embedded, embeddedOptions, isVeriffIframeMobile);
  window.addEventListener('message', handleMessage);
  return {
    close: closeIframe
  };
}

export { MESSAGES, createVeriffFrame };
